(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["borever-color-gallery-filter"]) return;
  try {
    
  (() => {
    const initializeFilters = () => {
      const configs = document.querySelectorAll('[data-borever-color-gallery-config]');

      configs.forEach((configNode) => {
        if (configNode.dataset.initialized === 'true') return;
        configNode.dataset.initialized = 'true';

        const config = JSON.parse(configNode.textContent);
        let scheduled = false;

      const mediaIdFrom = (value) => String(value || '').split('-').pop();

      const currentVariantId = () => {
        const productInfo = document.querySelector('product-info');
        const variantInput = productInfo?.querySelector('form[action*="/cart/add"] input[name="id"]');
        const urlVariant = new URL(window.location.href).searchParams.get('variant');
        return String(variantInput?.value || urlVariant || config.initialVariantId);
      };

      const colorGroupFromValue = (value) => {
        const normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'gray' || normalized === 'сірий') return 'gray';
        if (normalized === 'khaki' || normalized === 'хакі') return 'khaki';
        if (normalized === 'blue' || normalized === 'синій') return 'blue';
        return null;
      };

      const selectedColorGroup = () => {
        const selectedValues = [
          ...Array.from(document.querySelectorAll('product-info input[type="radio"]:checked')).map((input) => input.value),
          ...Array.from(document.querySelectorAll('product-info select')).map((select) => select.value),
        ];
        return selectedValues.map(colorGroupFromValue).find(Boolean) || null;
      };

      const applyFilter = () => {
        scheduled = false;
        const groupName = selectedColorGroup() || config.variantGroups[currentVariantId()];
        const allowedIds = new Set(config.mediaGroups[groupName] || []);
        if (!allowedIds.size) return;

        const gallery = document.querySelector('media-gallery[id^="MediaGallery-"]');
        if (!gallery) return;

        const galleryItems = Array.from(gallery.querySelectorAll('li[data-media-id]'));
        const thumbnailItems = Array.from(gallery.querySelectorAll('li[data-target]'));

        galleryItems.forEach((item) => {
          const isAllowed = allowedIds.has(mediaIdFrom(item.dataset.mediaId));
          item.classList.toggle('borever-color-media-hidden', !isAllowed);
          item.toggleAttribute('aria-hidden', !isAllowed);
        });

        thumbnailItems.forEach((item) => {
          const isAllowed = allowedIds.has(mediaIdFrom(item.dataset.target));
          item.classList.toggle('borever-color-media-hidden', !isAllowed);
          item.toggleAttribute('aria-hidden', !isAllowed);
        });

        document.querySelectorAll('product-modal [data-media-id]').forEach((item) => {
          const isAllowed = allowedIds.has(mediaIdFrom(item.dataset.mediaId));
          item.classList.toggle('borever-color-media-hidden', !isAllowed);
          item.toggleAttribute('aria-hidden', !isAllowed);
        });

        const visibleItems = galleryItems.filter((item) => !item.classList.contains('borever-color-media-hidden'));
        const activeItem = galleryItems.find((item) => item.classList.contains('is-active'));

        if (visibleItems.length && !visibleItems.includes(activeItem)) {
          const firstVisibleItem = visibleItems[0];

          if (typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(firstVisibleItem.dataset.mediaId, false);
          } else {
            galleryItems.forEach((item) => item.classList.remove('is-active'));
            firstVisibleItem.classList.add('is-active');

            thumbnailItems.forEach((item) => {
              item.querySelector('button')?.removeAttribute('aria-current');
            });
            gallery
              .querySelector(`[data-target="${firstVisibleItem.dataset.mediaId}"] button`)
              ?.setAttribute('aria-current', 'true');
          }
        }

        const activeIndex = Math.max(visibleItems.findIndex((item) => item.classList.contains('is-active')), 0);
        const currentCounter = gallery.querySelector('.slider-counter--current');
        const totalCounter = gallery.querySelector('.slider-counter--total');
        if (currentCounter) currentCounter.textContent = String(activeIndex + 1);
        if (totalCounter) totalCounter.textContent = String(visibleItems.length);
      };

      const scheduleFilter = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => window.setTimeout(applyFilter, 80));
      };

      document.addEventListener('change', (event) => {
        if (event.target.closest('variant-selects, variant-radios, product-info')) scheduleFilter();
      });

      document.addEventListener('shopify:section:load', scheduleFilter);
      window.addEventListener('popstate', scheduleFilter);

      const observer = new MutationObserver(scheduleFilter);
      observer.observe(document.body, { childList: true, subtree: true });

        scheduleFilter();
        window.setTimeout(applyFilter, 250);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFilters, { once: true });
    } else {
      initializeFilters();
    }

    document.addEventListener('shopify:section:load', initializeFilters);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();

    }


    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }


    disconnectedCallback() {

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }


    createObserver() {

      let observer = new IntersectionObserver(
        (entries, observer) => {

          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();

        }
      );

      observer.observe(this.header);

    }


    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) return;


      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        } else {

          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(() => {

              this.preventReveal = false;

            }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );

      }

      this.currentScrollTop = scrollTop;

    }


    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();

    }


    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }


    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }


    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) => disclosure.close()
      );

    }


    closeSearchModal() {

      this.searchModal =
        this.header.querySelector(
          'details-modal'
        );

      if (this.searchModal) {
        this.searchModal.close(false);
      }

    }

  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );


  } catch(e) { console.error(e); }
})();
})();
